// Live's "Prompt Shortcuts" (#242, `editor-depth/SPEC.md` B6): the chat box's paperclip opens it;
// "Search prompts..." narrows the list, "No prompts found." when nothing matches, and a pick puts
// its prompt in the chat box and closes it, the search cleared (live's).
import { CloseButton, Modal, Text, TextInput, UnstyledButton } from "@mantine/core";
import { Search } from "lucide-react";
import { useState } from "react";

import { shortcutGroups } from "./prompt-shortcuts";
import classes from "./assistant.module.css";

export function PromptShortcuts(props: { opened: boolean; onClose: () => void; onPick: (prompt: string) => void }) {
  const [search, setSearch] = useState("");
  const groups = shortcutGroups(search);
  const close = () => {
    setSearch("");
    props.onClose();
  };
  return (
    <Modal
      opened={props.opened}
      onClose={close}
      // Live's title is for screen readers only, and it has no close button.
      title="Prompt Shortcuts"
      withCloseButton={false}
      size={700}
      centered
      padding={0}
      classNames={{ header: classes.shortcutsHeader, body: classes.shortcutsBody }}
    >
      <TextInput
        aria-label="Search prompts"
        placeholder="Search prompts..."
        value={search}
        onChange={(event) => setSearch(event.currentTarget.value)}
        leftSection={<Search size={16} aria-hidden />}
        rightSection={search === "" ? null : <CloseButton size="sm" aria-label="Clear search" onClick={() => setSearch("")} />}
        variant="unstyled"
        className={classes.shortcutsSearch}
        data-autofocus
      />
      <div className={classes.shortcutsList}>
        {groups.length === 0 ? (
          <Text className={classes.shortcutsNone}>No prompts found.</Text>
        ) : (
          groups.map(({ group, shortcuts }) => (
            <section key={group} aria-label={group} className={classes.shortcutsGroup}>
              <Text className={classes.shortcutsGroupTitle}>{group}</Text>
              {shortcuts.map((shortcut) => (
                <UnstyledButton
                  key={shortcut.id}
                  className={classes.shortcut}
                  onClick={() => {
                    props.onPick(shortcut.prompt);
                    close();
                  }}
                >
                  <span className={classes.shortcutTitle}>{shortcut.title}</span>
                  <span className={classes.shortcutText}>{shortcut.description}</span>
                </UnstyledButton>
              ))}
            </section>
          ))
        )}
      </div>
    </Modal>
  );
}
